/**
 * Clerk publishable key (frontend). Vite puede unificar varias fuentes en build — ver vite.config.ts.
 * Plan B: el Worker también inyecta `window.__EDGE_RUNTIME_CONFIG__.clerkPublishableKey`.
 */

import { edgeRuntimeString } from "@/lib/edgeRuntimeConfig";

export function getClerkPublishableKey(): string | undefined {
  const fromWorker = edgeRuntimeString("clerkPublishableKey");
  if (fromWorker) return fromWorker;
  const raw = (
    (import.meta.env.VITE_CLERK_PUBLISHABLE_KEY as string | undefined) ||
    (import.meta.env.NEXT_PUBLIC_CLERK_PUBLISHABLE_KEY as string | undefined) ||
    ""
  ).trim();
  return raw.length > 0 ? raw : undefined;
}

/** true si parece una publishable key de Clerk (pk_test_ / pk_live_). */
export function isLikelyClerkPublishableKey(key: string): boolean {
  const k = key.trim();
  if (k.length < 16) return false;
  return k.startsWith("pk_test_") || k.startsWith("pk_live_");
}
